var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodpressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.35055C0 3.05549 2.12086 0 5.02507 0C7.04041 0 8.53587 1.37089 9.45895 3.3156C10.382 1.37102 11.8774 0 13.8928 0C16.7974 0 18.9179 3.05603 18.9179 6.35055C18.9179 6.9348 18.853 7.50501 18.7339 8.05951C17.7222 6.77744 16.1795 5.95833 14.4512 5.95833C11.4038 5.95833 8.93346 8.50471 8.93346 11.6458C8.93346 13.8958 10.2009 15.8405 12.0399 16.763C10.5748 17.8253 9.45895 18.4167 9.45895 18.4167C9.45895 18.4167 0 13.7066 0 6.35055Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7652 11.9165C15.7652 12.5148 15.2947 12.9998 14.7142 12.9998C14.1338 12.9998 13.6632 12.5148 13.6632 11.9165C13.6632 11.8522 13.6687 11.7892 13.6791 11.7279L12.4077 10.4174L13.1509 9.65137L14.359 10.8966C14.4699 10.8555 14.5895 10.8332 14.7142 10.8332C15.2947 10.8332 15.7652 11.3182 15.7652 11.9165Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9178 11.6457C18.9178 14.1885 16.918 16.2498 14.4511 16.2498C11.9842 16.2498 9.98438 14.1885 9.98438 11.6457C9.98438 9.10287 11.9842 7.0415 14.4511 7.0415C16.918 7.0415 18.9178 9.10287 18.9178 11.6457ZM17.8668 11.6457C17.8668 13.5902 16.3376 15.1665 14.4511 15.1665C12.5646 15.1665 11.0354 13.5902 11.0354 11.6457C11.0354 9.70114 12.5646 8.12484 14.4511 8.12484C16.3376 8.12484 17.8668 9.70114 17.8668 11.6457Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodpressure);
export default __webpack_public_path__ + "static/media/Bloodpressure.cd44555c23f75dca0204cb164ca19ebb.svg";
export { ForwardRef as ReactComponent };